import { render, staticRenderFns } from "./withdrawItem.vue?vue&type=template&id=74ffd537&"
import script from "./withdrawItem.vue?vue&type=script&lang=js&"
export * from "./withdrawItem.vue?vue&type=script&lang=js&"
import style0 from "./withdrawItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports